import { useEffect, useRef } from 'react'
import { trackExperienceScored } from 'services/engagementTracking'

// a slider is settled once it has not moved for this long
export const SETTLE_MS = 1500

/** What Meta gets for a scorer result: the stage as the level, the rung and the readiness percentage */
export const scoreEventParams = (result, page) => ({
  page,
  level: result.stage,
  rung: result.rung,
  score: result.pct,
})

/** The same result twice is one event: a slider nudged back to where it was sends nothing */
export const sameScore = (a, b) => !!a && !!b && a.level === b.level && a.score === b.score

/**
 * Sends the scorer's result to Meta once the visitor has stopped moving the sliders, and again only when the
 * settled result differs from the last one sent. The page's example scores are never sent: `touched` is false
 * until the visitor moves a slider.
 */
export const useScoreEvent = ({ result, touched, page, send = trackExperienceScored }) => {
  const lastSent = useRef(null)
  useEffect(() => {
    if (!touched || !result) return undefined
    const params = scoreEventParams(result, page)
    if (sameScore(lastSent.current, params)) return undefined
    const timer = setTimeout(() => {
      lastSent.current = params
      send(params)
    }, SETTLE_MS)
    return () => clearTimeout(timer)
  }, [result, touched, page, send])
}
